import React from 'react'
import { PricingPlan } from '../types'
import { PricingPlanElement } from '../pricingPlan'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import ActionButton from 'uiComponents/buttons'
import { CancelButton } from 'uiComponents/buttons/cancelButton'
import './confirmActionModal.scss'

type ConfirmableAction = 'activate' | 'discontinue'

const actionCopy: Record<ConfirmableAction, { title: string; body: string; button: string }> = {
    activate: {
        title: 'Activate pricing plan',
        body: 'This plan will become the active offering for new members. Your current active plan will move to open status.',
        button: 'Activate',
    },
    discontinue: {
        title: 'Discontinue pricing plan',
        body: 'This plan will be discontinued. Renewals will be disabled, and existing memberships will continue until they end. The plan will close automatically afterward. This action can be reversed later.',
        button: 'Discontinue',
    },
}

interface ConfirmActionModalProps {
    pricingPlan: PricingPlan
    action: ConfirmableAction
    onConfirm: () => void
    onDismiss: () => void
}

export const ConfirmActionModal = ({ pricingPlan, action, onConfirm, onDismiss }: ConfirmActionModalProps) => {
    const copy = actionCopy[action]

    return (
        <Modal className="confirm-action-modal" title={copy.title} onDismiss={onDismiss}>
            <ModalBody>
                <p>{copy.body}</p>
                <PricingPlanElement pricingPlan={pricingPlan} readOnly />
            </ModalBody>
            <ModalFooter>
                <CancelButton onClick={onDismiss} size="large" />
                <ActionButton size="large" onClick={onConfirm}>
                    {copy.button}
                </ActionButton>
            </ModalFooter>
        </Modal>
    )
}
